import React from 'react'
import LogContainer from './LogContainer.js'
import PropTypes from 'prop-types'
import ButterToast, { POS_TOP, POS_RIGHT } from 'butter-toast'

import { StateProvider } from '../state'

const App = props => {
  const initialState = {
    logs: [],
    selectedLog: null,
    userId: props.userId,
  }

  const reducer = (state, action) => {
    switch (action.type) {
      case 'selectLog':
        return {
          ...state,
          selectedLog: action.selectedLog,
        }
      case 'updateLogs':
        return {
          ...state,
          logs: action.logArray,
        }
      default:
        return state
    }
  }

  return (
    <StateProvider initialState={initialState} reducer={reducer}>
      <ButterToast
        position={{ vertical: POS_TOP, horizontal: POS_RIGHT }}
        style={{ top: '65px' }}
      />
      <LogContainer />
    </StateProvider>
  )
}

export default App

App.propTypes = {
  userId: PropTypes.string,
}
